
import { Component, Vue, Emit, Prop, Watch } from 'vue-property-decorator'
import { googleMaps } from 'vue2-google-maps'
import { isMobile, isTablet, isIE } from 'mobile-device-detect'
import PlatMapLotInfobox from './../components/modal/PlatMapInfoWindow.vue'
import PlatMapAminityInfobox from './../components/modal/PlatMapAmenityInfoWindow.vue'
import { getPlatMapModalPosition, getPlatMapModalPositionMobile, getCentroid, fitSVGToContainer, getPositiveValue, tranformOriginOfElement, getTransformMatrix, calculateUnderlayMobileLotPosition } from './../core'
import { apiFetchAminityInfo, apiFetchLotInfo } from './../api'
import { Status, Settings, HomeType, UrlFilterList } from './../constant'
import { LotDetail, LotPosition, Amenity, LotInfo, Sibling, LotCount, NeighborhoodsLots, NeighborhoodInfo, LotCountNeighborhood, CommunityQmiDetails, AmenityInfo, SidebarHomePlan, NeighboorhoodCoords, QmiDetails, CommunityFutureHomePlans, ComparedSvgFooterData } from './../types'
declare global {
  interface Window {
    google: {
      maps: googleMaps
    }
  }
}

@Component
export default class PlatMapMain extends Vue {
  $overlay!: any
  $refs!: any
  $router!: any
  $gmap!: any
  $elmnt!: HTMLElement
  styleObject: any = {
    height: `${window.innerHeight - 70}px`,
    width: `${window.innerWidth}px`,
  }
  private svgZoom = isMobile ? Settings.MOBILE_DEFAULT_SVG_SCALE : 1
  // private mapDefaultZoom = Settings.MAP_DEFAULT_SVG_SCALE
  private isDisabledZoomOut = false
  private isDisabledZoomIn = false
  private pos1 = 0
  private pos2 = 0
  private pos3 = 0
  private pos4 = 0
  private evCache: any = []
  private prevDiff = -1
  private idleListner: any
  private amenityId: string
  private selectedLotId: string
  private googleInfoWindow: any
  private googleAmenityInfoWindow: any
  private hasMobile = !!(isMobile && !isTablet);
  private lotsCount: LotCount = {
    available: 0,
    model: 0,
    quickmovein: 0,
    sold: 0,
    reserved: 0,
  }
  private selectedCommunityLots = [] as LotDetail[];
  private lastNeighborhoodVisited = "";
  private neighborhoodLotsCount = [] as LotCountNeighborhood[]
  private selectedNeighborhoodLots!: LotDetail[]
  private uniqueAminity = [] as string[]
  private amenityInfo = [] as AmenityInfo[];
  private lotDetail = [] as Element[];
  private svgContainer = '' as any;
  private ns = "http://www.w3.org/2000/svg";
  private notReservedPlan = new Set<string>();
  private selectQmiData = {} as QmiDetails;
  @Prop() private qmiDetails!: CommunityQmiDetails;
  @Prop() homeplans!: SidebarHomePlan[];
  @Prop() private neighborhoods!: NeighborhoodInfo[]
  @Prop() private selectedNeighborhoodIds!: string[]
  @Prop() private underlay!: boolean
  @Prop() private lots!: NeighborhoodsLots[]
  @Prop() private amenities!: Amenity[]
  @Prop() private svg!: string
  @Prop() private selectedHomePlanId!: string
  @Prop() private selectedJobNum!: string
  @Prop() private neighborhoodId!: string
  @Prop() private sibling: Sibling[]
  @Prop() private communityId!: string
  @Prop() private centerLat!: number
  @Prop() private centerLong!: number
  @Prop() private neighborhoodCenterLat!: number
  @Prop() private neighborhoodCenterLong!: number
  @Prop() private swCornerLong!: number
  @Prop() private swCornerLat!: number
  @Prop() private neCornerLong!: number
  @Prop() private neCornerLat!: number
  @Prop() private mapDefaultZoom!: number
  @Prop() private isKioskMode!: boolean
  @Prop() private listPlanId!: string[]
  @Prop() private futureHomePlans!: CommunityFutureHomePlans

  @Emit("updateFooterData") updateFooterData(matchedSvgfooterData: ComparedSvgFooterData[]) { }
  @Emit("showPlanFutureLotFlyout") showPlanFutureLotFlyout(lotInfo: LotInfo, lotId: string) { }
  @Emit("updateNotOnlyReservedPlan") updateNotOnlyReservedPlan(notReservedPlan: Set<string>) { }
  @Prop() private hoverNeighborZoomLevel: number;
  @Prop() private isDisableHoverNeighbor!: boolean;
  @Prop() private centerMap: NeighboorhoodCoords;
  @Emit('setZoomLevelMapPage') setZoomLevelMapPage(zoomLevel: number) { }
  @Emit('setAmenities') setAmenities(amenities: Array<string>) { }
  @Emit('CleanHomeId') CleanHomeId() { }
  @Emit('loadLotInfo') loadLotInfo(lotId: string, homeplanIds: string[], lotPosition: LotPosition, status: string) { }
  @Emit('loadAminityInfo') loadAminityInfo(amenityId: string, lotPosition: LotPosition) { }
  @Emit('closeLotInfo') closeLotInfo() { }
  @Emit("setselectQmiData") setselectQmiData(selectQmiData: QmiDetails) { }
  @Emit('closeAmenityInfo') closeAmenityInfo() { }

  @Emit('handleVisitClick') handleVisitClick() {
    this.closeMapInfoWindow()
  }
  @Emit('calculateContactInfoTopPosition') calculateContactInfoTopPosition() { }
  @Watch('selectedNeighborhoodIds') showCommunity(newValue: string[], oldValue: string[]) {
    if (newValue !== oldValue) {
      this.lotDetail = this.getLots(this.selectedNeighborhoodIds);
    }
    if (!newValue.length && oldValue.length) {
      this.showWholeCommunity()
    } else if (newValue.length && oldValue !== newValue) {
      this.$gmap.setZoom(this.mapDefaultZoom);
    }
    this.resetPlanClick();
  }

  resetQmiClick(pathData: Element[]) {
    if (this.selectedJobNum) {
      const qmi = document.getElementById(this.selectedJobNum) as Element;
      if (!pathData.includes(qmi)) {
        this.CleanHomeId();
      }
    }
  }
  resetPlanClick() {
    let pathData = this.getLots(this.selectedNeighborhoodIds);
    let selectedPlanExistCurrentNeighbor = false;
    if (this.selectedHomePlanId) {
      pathData.forEach((element: any) => {
        const homeplans = element.attributes['data-homeplans'].value
        const lotStatus = element.attributes['data-status'].value
        if (homeplans && lotStatus && lotStatus !== Status.RESERVED) {
          const planIds = homeplans.split(',')
          const planFound = this.lodash.includes(planIds, this.selectedHomePlanId);
          if (planFound) {
            selectedPlanExistCurrentNeighbor = true;
            return;
          }
        }
      })
      if (!selectedPlanExistCurrentNeighbor) {
        this.CleanHomeId();
      }
    }
    this.resetQmiClick(pathData);
  }
  @Watch('hoverNeighborZoomLevel') changeZoomOnNeighborHover(newVal: number, oldVal: number) {
    if (newVal !== oldVal && newVal !== 0) {
      setTimeout(() => {
        this.$gmap.setCenter({
          lat: +this.centerMap.latitude,
          lng: +this.centerMap.longitude
        });
        this.$gmap.setZoom(newVal);
      }, 300);
    }
  }
  @Watch('isDisableHoverNeighbor') disableHoverNeighbor(newVal: boolean, oldVal: boolean) {
    if (newVal && this.hoverNeighborZoomLevel === 0) {
      this.setCentreLatLong();
    }
  }
  @Watch('neighborhoodCenterLat') setCentreLatLong() {
    this.showWholeCommunity();
    this.$gmap.setCenter({
      lat: +this.neighborhoodCenterLat,
      lng: +this.neighborhoodCenterLong,
    });
    setTimeout(() => {
      this.$gmap.setZoom(this.mapDefaultZoom);
    }, 200);
  }

  @Watch("disablingHover") disableHover() {
    setTimeout(() => {
      if (this.isDisableHoverNeighbor) {
        this.setCentreLatLong();
      }
    }, 500)
  }

  get disablingHover() {
    return this.isDisableHoverNeighbor + " " + this.hoverNeighborZoomLevel;
  }
  showWholeCommunity() {
    const bound = this.$gmap.getBounds();
    const cornerCoords = [{ lat: this.swCornerLat, lng: this.swCornerLong }, { lat: this.neCornerLat, lng: this.neCornerLong }];
    cornerCoords.forEach((coord) => {
      bound.extend(coord);
    });
    const zoomLevel = this.setZoomLevel();
    this.$gmap.setCenter({ lat: this.centerLat, lng: this.centerLong })
    this.$gmap.setZoom(zoomLevel);
  }

  setZoomLevel() {
    const map = document.getElementById('map') as HTMLMapElement;
    const mapWidth = map.offsetWidth;
    const mapHeight = map.offsetHeight;

    const bounds = this.$gmap.getBounds().extend({ lat: this.swCornerLat, lng: this.swCornerLong }, { lat: this.neCornerLat, lng: this.neCornerLong });
    const worldCoordinateWidth = Math.abs(this.neCornerLong - this.swCornerLong);
    const worldCoordinateHeight = Math.abs(this.neCornerLat - this.swCornerLat);
    const zoomWidth = Math.floor(Math.log2(mapWidth / worldCoordinateWidth));
    const zoomHeight = Math.floor(Math.log2(mapHeight / worldCoordinateHeight));
    return Math.min(zoomWidth, zoomHeight);
  }

  @Watch('callHiglightLots')
  onJobNumPlanIdChanged(val: string, oldVal: string) {
    if (val !== oldVal) {
      this.highlightMatchedLots(this.selectedHomePlanId, this.selectedJobNum);
    }
  }

  get callHiglightLots() {
    return this.selectedHomePlanId + " " + this.selectedJobNum + " " + this.selectedNeighborhoodIds;
  }

  @Watch('isDisabledZoomOut') isZoomOutDisabled() {
    this.disableZoomOut()
  }
  @Watch('isDisabledZoomIn') isZoomInDisabled() {
    this.disableZoomIn()
  }

  @Watch('selectedNeighborhoodIds') showNeighborhoods() {
    this.hideSibling();
  }
  @Emit("hideSibling") hideSibling() { }
  @Emit("updateLotInfo") updateLotInfo(lotDetail: LotInfo | LotDetail, lotId: string) { }
  @Emit('disableZoomIn') disableZoomIn() { }
  @Emit('disableZoomOut') disableZoomOut() { }
  @Emit('hideSidebar') hideSidebar() { }
  @Emit('hideHeader') hideHeader() { }
  @Emit('hideFooter') hideFooter() { }
  @Emit('showHeader') showHeader() { }
  @Emit('showFooter') showFooter() { }
  @Emit('showSidebar') showSidebar() { }
  @Emit('calculateSoldLotsPercentage') calculateSoldLotsPercentage(lotsCountNeighborhood: LotCountNeighborhood[]) { }

  mountVueOverlay() {
    const svgContainer = this.mapSvgContainer()
    let VueOverlay = function (bounds, options) {
      this.$el = svgContainer
      this.$bounds = bounds
      this.$centered = options.centered
    }
    VueOverlay.prototype = new window.google.maps.OverlayView()
    VueOverlay.prototype.constructor = VueOverlay
    VueOverlay.prototype.onAdd = function () {
      this.$el.style.position = 'absolute'
      let panes = this.getPanes()
      panes.overlayMouseTarget.appendChild(this.$el)
    }

    VueOverlay.prototype.onRemove = function () {
      this.$el.parentNode.removeChild(this.$el)
    }

    VueOverlay.prototype.draw = function () {
      let overlayProjection = this.getProjection()
      let sw = overlayProjection.fromLatLngToDivPixel(this.$bounds.getSouthWest())
      let ne = overlayProjection.fromLatLngToDivPixel(this.$bounds.getNorthEast())
      let div = this.$el
      let svgElement = div.querySelectorAll('svg')[0]
      div.style.left = sw.x + 'px'
      div.style.top = ne.y + 'px'
      div.style.width = ne.x - sw.x + 'px'
      div.style.height = sw.y - ne.y + 'px'
      svgElement.style.left = sw.x + 'px'
      svgElement.style.top = ne.y + 'px'
      svgElement.style.width = ne.x - sw.x + 'px'
      svgElement.style.height = sw.y - ne.y + 'px'
    }
    return VueOverlay
  }

  mounted() {
    if (!this.underlay) {
      this.platmapOverlay(false);
      this.compareFooterDataLotData();
    } else {
      this.selectQmi();
      this.$refs.mapRef.$mapPromise.then(() => {
        let VueOverlay = this.mountVueOverlay()
        const mapElement: HTMLElement = document.getElementById('map') as HTMLElement
        this.$gmap = new window.google.maps.Map(mapElement, {
          zoom: this.mapDefaultZoom,
          minZoom: Settings.MAP_MIN_SVG_SCALE,
          maxZoom: Settings.MAP_MAX_SVG_SCALE,
          center: { lat: this.centerLat, lng: this.centerLong },
          disableDefaultUI: true,
          disableDoubleClickZoom: true,
          clickableIcons: false,
        })
        const bounds = new window.google.maps.LatLngBounds(new window.google.maps.LatLng(this.swCornerLat, this.swCornerLong), new window.google.maps.LatLng(this.neCornerLat, this.neCornerLong))
        window.google.maps.event.addListener(this.$gmap, 'dragend', this.handleGoogleDragEnd)
        window.google.maps.event.addListener(this.$gmap, 'zoom_changed', this.handleGoogleMapZoom)
        this.$overlay = new VueOverlay(bounds, {
          centered: true,
          layer: 'overlayLayer',
        })
        this.idleListner = window.google.maps.event.addListener(this.$gmap, 'idle', this.googleMapIdle);
        this.$overlay.setMap(this.$gmap)
        this.$gmap.setCenter({
          lat: this.neighborhoodCenterLat,
          lng: this.neighborhoodCenterLong,
        })
      });
    }
  }

  selectQmi() {
    let qmiAddress = this.$route.query[UrlFilterList.LOT] as string;
    if (qmiAddress && qmiAddress.length) {
      const address = qmiAddress.split("-");
      qmiAddress = address.join(" ").toLowerCase();
      if (this.selectedNeighborhoodIds.length) {
        this.selectQmiData = this.qmiDetails[this.selectedNeighborhoodIds[0]].find(qmi => {
          const eachQmiAddress = qmi.address.split(" ");
          return eachQmiAddress.join(" ").toLowerCase() === qmiAddress;
        });
      } else {
        const allQmi = [] as QmiDetails[];
        Object.values(this.qmiDetails).forEach(qmi => allQmi.push(...qmi));
        const data = allQmi.find(qmi => {
          const eachQmiAddress = qmi.address.split(" ");
          return eachQmiAddress.join(" ").toLowerCase() === qmiAddress;
        });
        if (data) {
          this.selectQmiData = data;
        }
      }
      this.setselectQmiData(this.selectQmiData);
    }
  }

  googleMapIdle() {
    setTimeout(() => {
      this.compareFooterDataLotData();
      this.hideSibling()
      if (!this.selectedNeighborhoodIds.length && !this.selectQmiData.neighborhood_code) {
        this.showWholeCommunity();
      }
      if (this.selectQmiData.neighborhood_code) {
        this.selectedQmiClickEvent(this.selectQmiData.job_number);
        this.selectQmiData = {} as QmiDetails;
        this.setselectQmiData(this.selectQmiData);
      }
    }, 500)
    // this.hideSibling()

    window.google.maps.event.removeListener(this.idleListner)
  }

  underLayZoomIn(zoomStep) {
    const { zoom } = this.$gmap
    let newZoom = zoom + zoomStep
    if (newZoom >= Settings.MAP_MAX_SVG_SCALE) {
      this.isDisabledZoomIn = true
      newZoom = Settings.MAP_MAX_SVG_SCALE
    } else {
      this.isDisabledZoomIn = false
    }
    if (newZoom <= Settings.MAP_MIN_SVG_SCALE) {
      this.isDisabledZoomOut = true
      newZoom = Settings.MAP_MIN_SVG_SCALE
    } else {
      this.isDisabledZoomOut = false
    }
    this.$gmap.setZoom(newZoom)
  }

  normalZoomIn(zoomStep) {
    this.closeLotInfo()
    this.closeAmenityInfo()
    const { svgZoom } = this
    let newSvgZoom = svgZoom + zoomStep
    let mapMaxValue = isMobile ? Settings.MOBILE_MAX_SVG_SCALE : Settings.WEB_MAX_SVG_SCALE
    let mapMinValue = isMobile ? Settings.MOBILE_MIN_SVG_SCALE : Settings.WEB_MIN_SVG_SCALE
    if (newSvgZoom >= mapMaxValue) {
      this.isDisabledZoomIn = true
      newSvgZoom = mapMaxValue
    } else {
      this.isDisabledZoomIn = false
    }
    if (newSvgZoom <= mapMinValue && newSvgZoom <= 0) {
      this.isDisabledZoomOut = true
      newSvgZoom = mapMinValue
    } else {
      this.isDisabledZoomOut = false
    }
    this.svgZoom = newSvgZoom
    let overlayContainer = document.getElementById('plan-svg') as HTMLElement
    tranformOriginOfElement(overlayContainer, this.svgZoom, this.svgZoom)
  }

  svgZoomIn(zoomStep = 1) {
    if (this.underlay) {
      this.underLayZoomIn(zoomStep)
    } else {
      this.normalZoomIn(zoomStep)
    }
  }

  svgZoomOut(zoomStep = 1) {
    this.svgZoomIn(zoomStep * -1)
  }
  svgAutoFit() {
    if (this.underlay) {
      this.$gmap.setZoom(this.mapDefaultZoom)
      this.$gmap.setCenter({ lat: this.centerLat, lng: this.centerLong })
    } else {
      this.svgZoom = 1
      setTimeout(() => {
        this.platmapOverlay(true)
      }, 100)
    }
    this.isDisabledZoomOut = false
    this.isDisabledZoomIn = false
  }

  mapSvgContainer() {
    let div = document.createElement('div')
    div.style.border = 'none'
    div.style.borderWidth = '0px'
    div.style.position = 'absolute'
    let svgContainer = document.createElement('div')
    svgContainer.innerHTML = this.svg
    svgContainer.style.width = '100%'
    svgContainer.style.height = '100%'
    svgContainer.style.position = 'absolute'
    const neighborhoodIds = [] as string[];
    this.neighborhoods.forEach((neighborhood) => {
      neighborhoodIds.push(neighborhood.neighborhood_code);
    });
    const pathData = this.getLots(neighborhoodIds, svgContainer)
    this.lotDetail = this.getLots(this.selectedNeighborhoodIds, svgContainer);
    this.bindLotEvents(pathData)
    const amenities = this.getAmenities(this.communityId, svgContainer)
    this.bindAmenityEvents(amenities)
    this.removeSVGLegend(svgContainer)
    div.appendChild(svgContainer)
    this.svgContainer = svgContainer;
    return div
  }

  touchWheelEvents(overlayContainer) {
    if ('ontouchstart' in window) {
      this.initPinchInPinchOut(overlayContainer)
    } else {
      overlayContainer.addEventListener(
        'mousewheel',
        (e) => {
          this.scrollCallback(e)
        },
        {
          passive: false,
        }
      )
      overlayContainer.addEventListener(
        'DOMMouseScroll',
        (e) => {
          this.scrollCallback(e)
        },
        {
          passive: false,
        }
      )
    }
  }
  platmapOverlay(isFitCall) {
    let overlayContainer = document.getElementById('plan-svg') as HTMLElement
    overlayContainer.innerHTML = this.svg
    overlayContainer.style.position = 'absolute'
    this.hideSibling()
    fitSVGToContainer(overlayContainer)
    if (isMobile) {
      overlayContainer.ontouchstart = this.dragMouseDown
    } else {
      overlayContainer.onmousedown = this.dragMouseDown
    }
    this.touchWheelEvents(overlayContainer)
    const pathData = this.getLots(this.selectedNeighborhoodIds, overlayContainer)
    this.lotDetail = pathData;
    const amenities = this.getAmenities(this.communityId, overlayContainer)
    this.bindLotEvents(pathData)
    this.bindAmenityEvents(amenities)
    this.removeSVGLegend(overlayContainer)
    this.$elmnt = overlayContainer
    let rectangle = getCentroid(isFitCall)
    if (rectangle.scaleX > Settings.WEB_MAX_SVG_SCALE) rectangle.scaleX = Settings.WEB_DEFAULT_SVG_SCALE

    if (rectangle.scaleY > Settings.WEB_MAX_SVG_SCALE) rectangle.scaleY = Settings.WEB_DEFAULT_SVG_SCALE

    let width = overlayContainer.style.width;
    width = width.substring(0, width.length - 2);
    overlayContainer.style.transform = 'scale(1,1)'
    this.svgZoom = 1
    setTimeout(() => {
      rectangle = getCentroid(isFitCall)
      overlayContainer.style.left = (isMobile ? 0 : (+width / 2) + '') + 'px'
    }, 100)
  }

  scrollCallback(e) {
    e.preventDefault()
    let delta = (e.deltaY || -e.wheelDelta || e.detail) >> 10 || 1
    this.svgZoomIn(e.wheelDelta > 0 ? 0.5 : -0.5)
  }

  getSelectedNeighborhoodLots() {
    let selectedNeighborhoodLots = [] as LotDetail[];
    if (this.selectedNeighborhoodIds.length) {
      this.lots.forEach((neighborhoood) => {
        if (neighborhoood.neighborhood_code === this.selectedNeighborhoodIds[0]) {
          selectedNeighborhoodLots = neighborhoood.lots;
        }
      });
    }
    return selectedNeighborhoodLots;
  }

  calculateNeighborhoodLotsCount(neighborhood: NeighborhoodsLots) {
    const lotsCount: LotCountNeighborhood = {
      neighborhoodId: neighborhood.neighborhood_code,
      available: 0,
      model: 0,
      quickmovein: 0,
      sold: 0,
      reserved: 0,
      future: 0,
    }
    neighborhood.lots.forEach(lot => {
      const lotType = lot.status
        .toLowerCase()
        .replace(' ', '')
        .replace('-', '')
      if (lot.isFuturePlan) {
        lotsCount["future"] += 1
      } else {
        lotsCount[lotType] += 1
      }
    });
    this.neighborhoodLotsCount.push(lotsCount);
  }

  getAllCommunityLots() {
    let allCommunityLots = [] as LotDetail[];
    if (this.neighborhoods.length) {
      this.lots.forEach((neighborhoood) => {
        allCommunityLots.push(...neighborhoood.lots);
        this.calculateNeighborhoodLotsCount(neighborhoood);
      });
    }
    return allCommunityLots;
  }

  removeOnlyReservedLotPlan(lots: LotDetail[]) {
    lots.forEach((lot) => {
      if (lot.status !== Status.RESERVED) {
        lot.home_planes.forEach((element) => {
          const updatePlan = this.homeplans.find((plan) => plan.plan_id === element);
          if (updatePlan) this.notReservedPlan.add(updatePlan.plan_id);
        })
      }
    });
    this.updateNotOnlyReservedPlan(this.notReservedPlan);
  }

  selectedQmiClickEvent(lotId: string) {
    const lotDetail = this.lodash.find(this.selectedCommunityLots, {
      id: lotId,
    }) as LotDetail
    const element = document.getElementById(lotId);
    if (lotDetail && element) {
      const rect = element.getBoundingClientRect();
      const x = rect.left + window.scrollX + rect.width / 2;
      const y = rect.top + window.scrollY + rect.height / 2;
      const clickEvent = new MouseEvent('click', {
        bubbles: false,
        cancelable: true,
        view: window,
        clientX: x,
        clientY: y
      });
      element.dispatchEvent(clickEvent);
    }
  }

  removePlanFutureLot(lotDetail: LotDetail, lotId: string) {
    Object.values(this.futureHomePlans).forEach(plans => {
      const data = plans.find(plan => plan.job_number === lotId);
      if (data) {
        lotDetail.home_planes = [data.plan_id];
      }
    })
  }

  hideSvgHomeIcon(element: any) {
    if (element.children[1] &&
      element.children[1].attributes['id']) {
      const homeId = element.children[1].attributes['id'].value;
      element.children[1].style.display = homeId ? 'none' : 'flex';
    }
  }
  fillLotColor(pathTag: any, color: string) {
    if (pathTag.tagName === 'g') {
      pathTag.children[0].style.fill = color;
    } else {
      pathTag.style.fill = color;
    }
  }
  compareFooterDataLotData() {
    const neighborhoodStatus = [] as ComparedSvgFooterData[]
    this.lots.forEach((neighbor) => {
      const status = new Set<string>();
      neighbor.lots.forEach((lot) => {
        const lotPresentInSvg = document.getElementById(lot.id)
        if (lotPresentInSvg)
          status.add(lotPresentInSvg.getAttribute('data-status')?.toLowerCase() || "");
      });
      neighborhoodStatus.push({
        neighborhood_code: neighbor.neighborhood_code,
        status: Array.from(status),
      });
    });
    this.updateFooterData(neighborhoodStatus);
  }
  bindLotEvents(pathData: Element[]) {
    this.selectedCommunityLots = this.getAllCommunityLots();
    this.removeOnlyReservedLotPlan(this.selectedCommunityLots);
    pathData.forEach((element: any) => {
      const lotId = element.attributes['id'].value
      const lotDetail = this.lodash.find(this.selectedCommunityLots, {
        id: lotId,
      }) as LotDetail
      if (lotDetail) {
        this.updateLotInfo(lotDetail, lotDetail.id);
        element.style.fill = lotDetail.color
        this.removePlanFutureLot(lotDetail, lotId);

        // static data for viridian where normal plan is attached to only future lot 
        // if(lotDetail.home_planes.includes('BRHT') && lotDetail.id !== "VIR-0012-20") {
        //   const index = lotDetail.home_planes.findIndex((sibling) => sibling === "BRHT");
        //   console.log(index);
        //   console.log(lotDetail);
        //   lotDetail.home_planes.splice(index, 1);
        // }

        element.setAttribute('data-homeplans', lotDetail.home_planes)
        element.setAttribute('data-status', lotDetail.status)
        const circleTag = element.getElementsByTagName('circle')
        if (circleTag.length > 0) {
          circleTag[0].style.fill = lotDetail.color
        } else {
          const pathTag = element.children[0]
          if (pathTag) {
            this.fillLotColor(pathTag, lotDetail.color);
            this.hideSvgHomeIcon(element);
          }
        }
        if (lotDetail.status !== Status.RESERVED) {
          element.style.cursor = 'pointer'
          element.onclick = () => this.handleLotClick(lotId, this.getHomPlanIds(lotDetail), lotDetail ? lotDetail.status : '', event)
        }
      } else {
        this.hideSvgHomeIcon(element.children[0]);
        if (element.children.length) {
          if (element.children[0].children.length) {
            element.children[0].children[0].style.fill = '#EEE6D0'
          }
        } else {
          element.children[0].style.fill = '#EEE6D0'
        }
      }
    });
    this.calculateSoldLotsPercentage(this.neighborhoodLotsCount)
  }

  getHomPlanIds(lotDetail) {
    return lotDetail && (lotDetail.status === Status.AVAILABLE || Status.QUICK_MOVE_IN) ? lotDetail.home_planes : []
  }

  bindAmenityEvents(amenities: NodeListOf<Element>) {
    let amenityArr: Array<string> = []
    amenities.forEach((element: any) => {
      const amenityId = element.attributes['id'].value
      const amenityDetail = this.lodash.find(this.amenities, {
        id: amenityId,
      }) as LotDetail
      element.style.cursor = 'pointer'
      if (amenityDetail) {
        amenityArr.push(amenityId)
        element.onclick = (event) => {
          this.handleAminityClick(amenityId, event)
        }
      }
    })
    this.uniqueAminity = this.lodash.uniq(amenityArr);
    this.setAmenities(this.uniqueAminity)
  }

  removeSVGLegend(container: any) {
    const legends = container.querySelectorAll(`*[id^="Legend_"]`)
    legends.forEach((element: any) => {
      if (isIE) {
        element.parentNode.removeChild(element)
      } else {
        element.remove()
      }
    })
  }

  addClipPath(pathTag: any, color: string, count: number, lotId: string) {
    const clipPath = document.createElementNS(this.ns, "clipPath");
    clipPath.id = `${lotId}-${count}`;
    const d = pathTag.getAttribute('d');
    if (d) {
      const path = document.createElementNS(this.ns, "path") as any;
      path.setAttribute('d', d);
      path.setAttribute('fill', color)
      path.style.strokeWidth = "5";
      path.style.stroke = "white";
      clipPath.appendChild(path);
    } else {
      const polygon = document.createElementNS(this.ns, "polygon") as any;
      const points = pathTag.getAttribute('points');
      polygon.setAttribute('points', points);
      clipPath.appendChild(polygon);
    }
    return clipPath;
  }

  removeClipPath() {
    const svg = document.getElementsByTagName('svg')[0];
    const defChildNode = document.getElementById('isp-custom-defs');
    if (defChildNode) {
      svg.removeChild(defChildNode);
    }
  }

  updateSelectedQmi(jobNum: string) {
    let udatedQmiData;
    if (this.selectedNeighborhoodIds.length) {
      udatedQmiData = this.qmiDetails[this.selectedNeighborhoodIds[0]].find(qmi => qmi.job_number === jobNum);
    } else {
      const allQmi = [] as QmiDetails[];
      Object.values(this.qmiDetails).forEach(qmi => allQmi.push(...qmi));
      udatedQmiData = allQmi.find(qmi => qmi.job_number === jobNum);
    }
    if (udatedQmiData) {
      const newQuery = { ...this.$route.query };
      const address = udatedQmiData.address.split(" ").join("-")
      newQuery[UrlFilterList.LOT] = [address];
      this.$router.push({ query: newQuery }).catch(() => { });
    }
  }
  highlightQmiLot(jobNum: string, defs: Element, count: number, pathData: Element[]) {
    const element: any = document.querySelectorAll(`*[id="${jobNum}"]`);
    const qmiLotExistSelectedNeighbor = document.getElementById(jobNum) as Element;
    if (element.length && pathData.includes(qmiLotExistSelectedNeighbor)) {
      let pathTag = element[0].children[0];
      pathTag = this.resetElementCondoHome(pathTag);
      const color = pathTag.style.fill;
      const clipPath = this.addClipPath(pathTag, color, count, jobNum);
      if (clipPath) {
        defs.appendChild(clipPath);
      }
      element[0].children[1].style.display = 'flex';
      pathTag.style.stroke = 'white'
      pathTag.style.strokeWidth = 4
      pathTag.style.vectorEffect = 'non-scaling-stroke'
      pathTag.setAttribute('clip-path', `url(#${jobNum}-${count})`);
      count++;
    }
  }
  getplanAttachedLotsStatus(planId: string) {
    const planAttachedLotsStatus = new Set<string>();
    let pathData = this.getLots(this.selectedNeighborhoodIds, this.svgContainer);
    pathData.forEach((element: any) => {
      if (element.attributes['data-homeplans']) {
        const homeplans = element.attributes['data-homeplans'].value;
        if (homeplans) {
          const planIds = homeplans.split(',')
          const planFound = this.lodash.includes(planIds, planId);
          if (planFound) {
            planAttachedLotsStatus.add(element.attributes['data-status'].value);
          }
        }
      }
    });
    return planAttachedLotsStatus;
  }
  resetElementCondoHome(pathTag: any) {
    if (pathTag.tagName === 'g') {
      return pathTag.children[0];
    }
    return pathTag
  }

  applyBorder(element: any, planFound: boolean, defs: Element, count: number, strokeWidth: string, stroke: string, strokeEffect: string, homeIconVisibility: string) {
    let pathTag = element.children[0];
    pathTag = this.resetElementCondoHome(pathTag);
    const lotId = element.attributes['id'].value;
    const color = pathTag.style.fill;
    if (planFound) {
      const clipPath = this.addClipPath(pathTag, color, count, lotId);
      if (clipPath) {
        defs.appendChild(clipPath);
      }
      stroke = 'white';
      strokeWidth = '5';
      pathTag.setAttribute('clip-path', `url(#${lotId}-${count})`);
      strokeEffect = "non-scaling-stroke";
      count++;
      homeIconVisibility = 'flex';
    }
    if (element.children[1]?.attributes['id']?.value) {
      element.children[1].style.display = homeIconVisibility;
    }
    pathTag.style.stroke = stroke;
    pathTag.style.vectorEffect = strokeEffect;
    pathTag.style.strokeWidth = strokeWidth
  }

  deselectAllLots() {
    let pathData = this.getLots([]);
    pathData.forEach((element: any) => {
      if (element.attributes['data-homeplans']) {
        this.hideSvgHomeIcon(element);
        let pathTag = element.children[0];
        pathTag.style.stroke = '#111111';
        pathTag.style.vectorEffect = '';
        pathTag.style.strokeWidth = 'revert-layer';
      }
    })
  }

  highlightMatchedLots(selectedHomePlanId = "", jobNum = "") {
    let pathData = this.getLots(this.selectedNeighborhoodIds);
    this.removeClipPath();
    this.deselectAllLots();
    const defs = document.createElementNS(this.ns, "defs");
    defs.id = 'isp-custom-defs';
    let count = 0;
    pathData.forEach((element: any) => {
      if (element.attributes['data-homeplans']) {
        const homeplans = element.attributes['data-homeplans'].value
        const lotStatus = element.attributes['data-status'].value
        if (homeplans && lotStatus && lotStatus !== Status.RESERVED) {
          const planIds = homeplans.split(',')
          const planFound = this.lodash.includes(planIds, selectedHomePlanId)
          let strokeWidth = 'revert-layer';
          this.applyBorder(element, planFound, defs, count, strokeWidth, '#111111', "", 'none');
        }
      }
    })
    this.highlightQmiLot(jobNum, defs, count, pathData);
    const svg = document.getElementsByTagName('svg')[0];
    svg.appendChild(defs);
  }

  toggleBars() {
    document.querySelector('.embtoolbox')?.classList.toggle('mobhide');
    document.querySelector('.mobile-legends')?.classList.toggle('mobhide');
    document.querySelector('.cp-filter')?.classList.toggle('mobhide');
  }

  handleToggleBarsUnderlay() {
    if (this.hasMobile || (this.hasMobile && !this.underlay)) {
      this.toggleBars();
    }
    const isToolBoxHidden = document.querySelector('.embtoolbox')?.classList.contains('mobhide');
    if (!this.underlay && this.hasMobile && !isToolBoxHidden) {
      this.toggleBars();
    }
  }
  handleLotClick(lotId: string, homeplanIds: string[], status: string, event: any) {
    this.closeAmenityInfo()
    this.closeAmenityInfoWindow();
    let lotElement = document.getElementById(lotId) as HTMLElement
    if (lotElement && status === Status.QUICK_MOVE_IN) {
      this.updateSelectedQmi(lotId);
    }
    if (this.underlay && (isMobile || isTablet)) {
      this.handleToggleBarsUnderlay();
      this.bindLotInfo(this.getLatLong(event.x, event.y), lotId);
      this.CleanHomeId()
    } else {
      this.mobileHideHeader()
      let elementPosition = lotElement.getBoundingClientRect()
      const lotPosition = this.getPlatMapPosition(elementPosition)
      if (!this.underlay) {
        calculateUnderlayMobileLotPosition(lotPosition, elementPosition, this.svgZoom);
      }
      this.handleToggleBarsUnderlay();
      if (!event.bubbles && this.underlay)
        this.$gmap.setCenter(this.getLatLong(event.x, event.y))
      this.loadLotInfo(lotId, homeplanIds, lotPosition as LotPosition, status)
    }
  }

  getPlatMapPosition(elementPosition: DOMRect) {
    if (this.underlay && (isMobile || isTablet)) {
      return getPlatMapModalPositionMobile(elementPosition)
    } else {
      const zoom = this.underlay ? this.$gmap.getZoom() : 0;
      return getPlatMapModalPosition(elementPosition, 0, zoom)
    }
  }

  mobileHideHeader() {
    if (isMobile && this.underlay) {
      this.hideHeader()
      this.hideFooter()
    }
  }

  getLatLong(x: number, y: number) {
    const latLngBounds = this.$gmap.getBounds()
    const neBound = latLngBounds.getNorthEast()
    const swBound = latLngBounds.getSouthWest()
    const neBoundInPx = this.$gmap.getProjection().fromLatLngToPoint(neBound)
    const swBoundInPx = this.$gmap.getProjection().fromLatLngToPoint(swBound)
    const procX = x / document.documentElement.scrollWidth
    const procY = y / document.getElementById('mainWrap')!.scrollHeight
    const newLngInPx = (neBoundInPx.x - swBoundInPx.x) * procX + swBoundInPx.x
    const newLatInPx = (swBoundInPx.y - neBoundInPx.y) * procY + neBoundInPx.y
    return this.$gmap.getProjection().fromPointToLatLng(new window.google.maps.Point(newLngInPx, newLatInPx))
  }

  setMapCenterUsingPixel(x: number, y: number) {
    this.$gmap.setCenter(this.getLatLong(x, y))
  }

  handleAminityClick(amenityId: string, event: any) {
    this.closeLotInfo()
    this.closeMapInfoWindow()
    if (this.underlay) {
      if (this.hasMobile) {
        this.bindAminityInfo(this.getLatLong(event.x, event.y), amenityId);
        this.toggleBars();
      } else {
        this.amenityId = amenityId
        this.setMapCenterUsingPixel(event.x, event.y)
        window.setTimeout(() => {
          this.loadAminityInfoWindow()
        }, 300)
      }
    } else {
      this.amenityId = amenityId
      this.loadAminityInfoWindow()
    }
  }

  loadAminityInfoWindow() {
    let aminityElement = document.getElementById(this.amenityId) as HTMLElement
    let elementPosition = aminityElement.getBoundingClientRect()
    const lotPosition = isMobile || isTablet ? getPlatMapModalPositionMobile(elementPosition) : getPlatMapModalPosition(elementPosition, 0, 0)
    this.loadAminityInfo(this.amenityId, lotPosition as LotPosition)
  }

  dragMouseDown(e) {
    e = e || window.event
    //e.preventDefault();
    if (isMobile) {
      const touch = e.touches[0] || e.changedTouches[0]
      this.pos3 = touch.clientX
      this.pos4 = touch.clientY
      document.ontouchend = this.closeDragElement
      document.ontouchmove = this.elementDrag
    } else {
      this.pos3 = e.clientX
      this.pos4 = e.clientY
      document.onmouseup = this.closeDragElement
      document.onmousemove = this.elementDrag
    }
  }

  elementDrag(e) {
    e = e || window.event
    this.closeLotInfo()
    this.closeAmenityInfo()
    if (isMobile) {
      const touch = e.touches[0] || e.changedTouches[0]
      this.pos1 = this.pos3 - touch.clientX
      this.pos2 = this.pos4 - touch.clientY
      this.pos3 = touch.clientX
      this.pos4 = touch.clientY
    } else {
      this.pos1 = this.pos3 - e.clientX
      this.pos2 = this.pos4 - e.clientY
      this.pos3 = e.clientX
      this.pos4 = e.clientY
    }
    if (this.$elmnt) {
      this.$elmnt.style.top = this.$elmnt.offsetTop - this.pos2 + 'px'
      this.$elmnt.style.left = this.$elmnt.offsetLeft - this.pos1 + 'px'
    } else {
      let svgContainer = this.getSVGContainer()
      svgContainer.style.top = svgContainer.offsetTop - this.pos2 + 'px'
      svgContainer.style.left = svgContainer.offsetLeft - this.pos1 + 'px'
    }
  }

  closeDragElement() {
    if (isMobile) {
      document.ontouchend = null
      document.ontouchmove = null
    } else {
      document.onmouseup = null
      document.onmousemove = null
    }
  }

  getSVGContainer() {
    const platmapContainer = document.getElementById('platmap') as HTMLElement
    const svgElement = platmapContainer.getElementsByTagName('svg')[0] as SVGSVGElement
    const svgContainer = svgElement.parentNode as HTMLElement
    return svgContainer
  }

  getAmenities(communityId: string, container?: HTMLElement) {
    return container ? container.querySelectorAll(`*[id^="${communityId}::"]`) : document.querySelectorAll(`*[id^="${communityId}::"]`)
  }

  countLotsQmi(filteredHomePlans: any[], differentNeighbourhoodListItems: Set<any>) {
    filteredHomePlans.forEach((plan) => {
      if (plan.job_number) {
        const element: any = this.svgContainer ? this.svgContainer.querySelectorAll(`*[id="${plan.job_number}"]`) : document.querySelectorAll(`*[id="${plan.job_number}"]`);
        const availabilityDetails = element.length ? element[0].attributes['data-status'].value : null;
        if (element.length && this.isPlanCondoAndTownhome(plan) && this.isLotCounted(availabilityDetails, plan)) {
          differentNeighbourhoodListItems.add(element[0]);
        }
      }
    })
  }

  isPlanCondoAndTownhome(plan) {
    return !HomeType.includes(plan.plan_type.toLowerCase());
  }

  isLotCounted(availabilityDetails, plan) {
    return (availabilityDetails === Status.AVAILABLE || availabilityDetails === Status.QUICK_MOVE_IN || availabilityDetails === Status.FUTURE_HOME) && this.isPlanCondoAndTownhome(plan)
  }
  countLotsFilterPlans(filteredHomePlans) {
    const differentNeighbourhoodListItems = new Set();
    this.lotDetail.forEach((element: any) => {
      if (element.attributes['data-homeplans']) {
        const homeplans = element.attributes['data-homeplans'].value
        const availabilityDetails = element.attributes['data-status'].value
        if (homeplans) {
          const planIds = homeplans.split(',');
          let noPlanCondoTownhome = false;
          filteredHomePlans.forEach((plan) => {
            const planFound = this.lodash.includes(planIds, plan.plan_id);
            if (planFound && !noPlanCondoTownhome && this.isLotCounted(availabilityDetails, plan)) {
              noPlanCondoTownhome = true;
            }
          })
          if (noPlanCondoTownhome) {
            differentNeighbourhoodListItems.add(element)
          }
        }
      }
    })
    this.countLotsQmi(filteredHomePlans, differentNeighbourhoodListItems);
    return differentNeighbourhoodListItems.size;
  }
  getLots(neighborhoods: string[], container?: HTMLElement) {
    let nodeList = [] as Element[];
    if (neighborhoods.length) {
      neighborhoods.forEach(neighborhood => {
        const neighborhoodLots = container ? container.querySelectorAll(`*[id^="${neighborhood}-"]`) : document.querySelectorAll(`*[id^="${neighborhood}-"]`);
        nodeList = Array.from(nodeList).concat(Array.from(neighborhoodLots));
      });
    } else {
      this.neighborhoods.forEach((neighborhood) => {
        const neighborhoodLots = container ? container.querySelectorAll(`*[id^="${neighborhood.neighborhood_code}-"]`) : document.querySelectorAll(`*[id^="${neighborhood.neighborhood_code}-"]`);
        nodeList = Array.from(nodeList).concat(Array.from(neighborhoodLots));
      });
    }
    return nodeList;
  }

  initPinchInPinchOut(el) {
    el.onpointerdown = this.pointerdown_handler
    el.onpointermove = this.pointermove_handler
    el.onpointerup = this.pointerup_handler
    el.onpointercancel = this.pointerup_handler
    el.onpointerout = this.pointerup_handler
    el.onpointerleave = this.pointerup_handler
  }
  pointerdown_handler(ev) {
    this.evCache.push(ev)
  }
  pointermove_handler(ev) {
    for (let i = 0; i < this.evCache.length; i++) {
      if (ev.pointerId == this.evCache[i].pointerId) {
        this.evCache[i] = ev
        break
      }
    }
    if (this.evCache.length == 2) {
      let curDiff = Math.abs(this.evCache[0].clientX - this.evCache[1].clientX)
      this.callZoom(curDiff)
      this.prevDiff = curDiff
    } else {
      this.prevDiff = -1
    }
  }

  callZoom(curDiff) {
    if (this.prevDiff > 0) {
      if (curDiff > this.prevDiff) {
        this.svgZoomIn(0.02)
      }
      if (curDiff < this.prevDiff) {
        this.svgZoomOut(0.02)
      }
    }
  }

  pointerup_handler(ev) {
    this.remove_event(ev)
    if (this.evCache.length < 2) {
      this.prevDiff = -1
    }
  }
  remove_event(ev) {
    for (let i = 0; i < this.evCache.length; i++) {
      if (this.evCache[i].pointerId == ev.pointerId) {
        this.evCache.splice(i, 1)
        break
      }
    }
  }

  handleGoogleMapZoom() {
    this.closeLotInfo()
    this.closeAmenityInfo()
    const zoom = this.$gmap.getZoom()
    this.setZoomLevelMapPage(zoom);
    if (zoom === Settings.MAP_MAX_SVG_SCALE) {
      this.isDisabledZoomIn = true
    } else if (zoom == Settings.MAP_MIN_SVG_SCALE) {
      this.isDisabledZoomOut = true
    } else {
      this.isDisabledZoomIn = this.$gmap.getZoom() >= Settings.MAP_MAX_SVG_SCALE
      this.isDisabledZoomOut = this.$gmap.getZoom() <= Settings.MAP_MIN_SVG_SCALE
    }
  }

  handleGoogleDragEnd() {
    this.closeMapInfoWindow()
    this.closeAmenityInfoWindow()
    this.closeLotInfo()
    this.closeAmenityInfo()
    this.closeAmenityInfo();
  }

  closeMapInfoWindow() {
    if (this.googleInfoWindow) {
      this.googleInfoWindow.close()
      this.googleInfoWindow = "";
      if (this.selectedLotId && isTablet) {
        this.showHeader();
        this.showSidebar();
        this.showFooter();
      }
      if (this.selectedLotId && this.hasMobile) {
        this.toggleBars();
      }
      this.selectedLotId = "";
    }
  }

  closeAmenityInfoWindow() {
    if (this.googleAmenityInfoWindow) {
      this.googleAmenityInfoWindow.close()
      this.googleAmenityInfoWindow = "";
      if (this.amenityId && isTablet) {
        this.showHeader();
        this.showSidebar();
        this.showFooter();
      }
      if (this.amenityId && this.hasMobile) {
        this.toggleBars();
      }
      this.amenityId = "";
    }
  }

  async bindLotInfo(latLng, lotId: string) {
    this.closeMapInfoWindow()
    if (isTablet) {
      this.hideFooter();
      this.hideHeader();
      this.hideSidebar();
    }
    this.selectedLotId = lotId
    this.googleInfoWindow = new window.google.maps.InfoWindow()
    this.googleInfoWindow.setPosition(latLng)
    this.googleInfoWindow.open(this.$gmap)
    let currentLotNeighborhoodId = this.selectedLotId.split('-')[0];
    const data = await apiFetchLotInfo(currentLotNeighborhoodId, this.selectedLotId);
    const { result } = data;
    if (result && result.lot.id === this.selectedLotId) {
      this.showPlanFutureLotFlyout(result, lotId);
      result.neighborhoodName = this.neighborhoods.find((neighborhood) => neighborhood.neighborhood_code === currentLotNeighborhoodId)?.marketing_name;
      const InfoWindow = Vue.extend(PlatMapLotInfobox)
      const instance = new InfoWindow({
        propsData: {
          lotInfo: result,
          lotId: this.selectedLotId,
          isKioskMode: this.isKioskMode,
          neighborhoodId: currentLotNeighborhoodId,
          updateLotInfo: this.updateLotInfo,
          mobileOpenContactInfo: this.mobileOpenContactInfo
        }
      })
      instance.$mount()
      this.googleInfoWindow.setContent(instance.$el)
      this.googleInfoWindow.open(this.$gmap)
    }
    const closeElement = document.querySelector('.emb_closeicon')
    if (closeElement) {
      closeElement.addEventListener('click', () => {
        this.closeMapInfoWindow()
      })
    }
  }

  mobileOpenContactInfo() {
    this.calculateContactInfoTopPosition()
    this.handleVisitClick()
  }
  async bindAminityInfo(latLng, amenityId: string) {
    this.closeAmenityInfoWindow();
    if (isTablet) {
      this.hideFooter();
      this.hideHeader();
      this.hideSidebar();
    }
    this.amenityId = amenityId;
    this.googleAmenityInfoWindow = new window.google.maps.InfoWindow()
    this.googleAmenityInfoWindow.setPosition(latLng)
    this.googleAmenityInfoWindow.open(this.$gmap)
    this.$gmap.setCenter(latLng);
    const data = await apiFetchAminityInfo(amenityId);
    const { result } = data;
    this.amenityInfo = result;
    if (result && result[0].id === amenityId) {
      const InfoWindow = Vue.extend(PlatMapAminityInfobox)
      const instance = new InfoWindow({
        propsData: {
          amenityInfo: result,
          amenityId: amenityId,
          isKioskMode: this.isKioskMode,
          uniqueAminity: this.uniqueAminity,
          amenities: this.amenities,
          loadNewAmenity: this.loadNewAmenity
        }
      })
      instance.$mount()
      this.googleAmenityInfoWindow.setContent(instance.$el)
      this.googleAmenityInfoWindow.open(this.$gmap)
    }
    const closeElement = document.querySelector('.emb_closeicon')
    if (closeElement) {
      closeElement.addEventListener('click', () => {
        this.closeAmenityInfoWindow()
      })
    }
  }

  loadNewAmenity() {
    let currentIndex = this.uniqueAminity.indexOf(this.amenityId);
    const nextIndex = ++currentIndex % this.uniqueAminity.length;
    const amenityId = this.uniqueAminity[nextIndex];
    const amenityElement = document.getElementById(amenityId) as HTMLElement;
    if (amenityElement) {
      const amenityElementPosition = amenityElement.getBoundingClientRect();
      this.bindAminityInfo(this.getLatLong(amenityElementPosition.x, amenityElementPosition.y), amenityId);
    }
    if (this.hasMobile) {
      this.toggleBars();
    }
  }
}
